<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
          </div>
          <!-- <label for="voucher" class="col-sm-1 control-label">Voucher</label> -->
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button icon="pi pi-search" @click.prevent="searchOrder"
                    class="p-button-raised" label="Search"/>
          </div>
        </div>
        <Dialogs header="Reason" :visible.sync="ecommerceStatusDialog"
                 :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
          <div class="col-md-12">
            <label for="reason" class="col-md-4 control-label">Reason</label>
            <div class="form-group col-md-8">
              <textarea class="form-control" rows="5" v-model="reason"></textarea>
            </div>
          </div>
          <template #footer>
            <Button class="p-button-raised p-button-success" @click.prevent="updateOrderStatus"
                    label="Send"/>
            <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
          </template>
        </Dialogs>
      </form>


      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <a href="#" class="p-field p-col-12 p-md-12" @click.prevent="exportCSV()" v-if="this.    ecommerceOrderCompletedList.length > 0">
            <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
          </a>
          <DataTable :value="ecommerceOrderCompletedLists" dataKey="id" ref="dt" :selection.sync="selectedSalesOrderId"
                     :paginator="true" editMode="cell"

                     :rows="10" :filters="filters"
                     class=" p-datatable-gridlines editable-cells-table">
            <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->
            <Column header="S.N">
              <template #body="sl">
                {{ sl.index + 1 }}
              </template>
            </Column>
            <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="orderDateNepali"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['orderDateNepali']"/>
              </template>
            </Column>
            <Column header="Date" headerStyle="width:8em;" :sortable="true" field="orderDate" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['orderDate']"/>
              </template>
            </Column>
            <Column header="Order No" :sortable="true" field="orderNo" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['orderNo']"/>
              </template>
            </Column>
            <Column header="Customer" :sortable="true" field="customerName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['customerName']"/>
              </template>
            </Column>
            <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
              </template>
            </Column>
            <Column header="Contact" :sortable="true" field="primaryContact" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['primaryContact']"/>
              </template>
            </Column>
            <Column header="Bill Amount" bodyStyle="text-align: right" :sortable="true" field="billAmount"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['billAmount']"/>
              </template>
            </Column>
          
            <Column field="status" header="Status" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['status']"/>
              </template>
              <!-- <template #editor="slotProps">
                <Dropdown v-model="slotProps.data['status']" :options="statuses"
                          @change="showReasonDialog(slotProps.data)"
                          optionLabel="label" optionValue="value" placeholder="Select a Status"
                          :disabled="slotProps.data['status']==='Completed'?true:false">
                  <template #option="slotProps">
                <span
                  :class="'product-badge status-' + slotProps.option.value.toLowerCase()">{{
                    slotProps.option.label
                  }}</span>
                  </template>
                </Dropdown>
              </template> -->
              <template #body="slotProps">
                {{ getStatusLabel(slotProps.data.status) }}
              </template>
            </Column>
            <Column header="Action" headerStyle="width:12em;">
              <template #body="slotProps">
                <!-- Edit Button -->
                <!-- <Button icon="pi pi-pencil" v-if="enableEdit" class="p-button-raised p-button-success"
                        @click="editSalesOrder(slotProps.data)"/>
                <Button icon="pi pi-pencil" v-else disabled class="p-button-raised p-button-success"
                        @click="editSalesOrder(slotProps.data)"/> -->
                <!-- Edit button -->
                <!-- DeleteButton -->
                <Button v-if="enableDelete" class="p-button-raised p-button-danger"
                        @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
                <Button v-else disabled class="p-button-raised p-button-danger"
                        @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
                <!-- Delete Button -->
                <Button class="p-button-raised" @click="viewPIVDetail(slotProps.data)"
                        icon="pi pi-eye"/>
                <!-- <Button class="p-button-raised p-button-secondary"
                        @click="exportToPdf(slotProps.data.id)"
                        icon="pi pi-print"/> -->
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <!-- <div class="p-grid p-col-12 p-md-3 p-mt-2">
        <Button class="p-button-raised p-button-success" label="Download Order Sheet"
                @click.prevent="expexportToPdfOrderortToPdf()"/>
      </div> -->

    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Dropdown from 'primevue/dropdown'
import Dialogs from 'primevue/dialog'
import Checkbox from 'primevue/checkbox'
import Button from 'primevue/button'

export default {
  name: 'ecommerceReport',
  props: ['status'],
  data() {
    return {
      fromDate: null,
      toDate: null,
      ecommerceOrderCompletedList: [],
      loading: false,
      dialogShow: false,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      idsForSalesOrder: [],
      selectedSalesOrderId: null,
      ecommerceStatusDialog: false,
      reason: '',
      ecommerceStatusData: '',
      inventoryHeaderId: null,
      salesOrderId: null,
      enableEdit: false,
      enableDelete: false,
      // [{label: 'In Stock', value: 'INSTOCK'},{label: 'Low Stock', value: 'LOWSTOCK'},{label: 'Out of Stock', value: 'OUTOFSTOCK'}]
      statuses: [{label: 'Processing', value: 'Processing'}, {label: 'Hold', value: 'Hold'}, {
        label: 'Completed',
        value: 'Completed'
      }, {label: 'Cancelled', value: 'Cancelled'}]
    }
  },
  mounted() {
    if (this.status !== undefined) {
      this.$toast.add({severity: 'success', summary: '', detail: this.status.message, life: 3000})
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.checkEnableEdit()
    this.checkEnableDelete()
  },
  computed: {
    ecommerceOrderCompletedLists() {
      return this.$store.state.website.ecommerceOrderCompletedLists
    }
  },
  methods: {
    async searchOrder() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadecommerceOrderCompletedLists', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 3000})
      } else {
        this.ecommerceOrderCompletedList = resp.data.data
      }
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        orderDate: data.orderDateNepali,
        orderNo: data.orderNo,
        remarks: data.remarks,
        customerName: data.customerName,
        primaryContact: data.primaryContact,
        secondaryContact: data.secondaryContact,
        address: data.address,
        shippingAddress: data.shippingAddress,
        billAmount: data.billAmount
      }
      this.$router.push({name: 'Order Details', params: {salesHeaderObj: PIHdata}})
    },
    async updatePaid() {
      let data = {
        salesOrderId: this.idsForSalesOrder
      }
      let resp = await this.$store.dispatch('updatePaidForVendor', data)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.ecommerceStatusDialog = false
      }
    },
    showReasonDialog(data) {
      this.inventoryHeaderId = data.id
      this.ecommerceStatusData = data.ecommerceStatus
      if (data.ecommerceStatus === 'Hold' || data.ecommerceStatus === 'Cancelled') {
        this.ecommerceStatusDialog = true
        this.inventoryHeaderId = data.id
        this.ecommerceStatusData = data.ecommerceStatus
      }
      if (data.ecommerceStatus === 'Completed' || data.status === 'Processing') {
        this.reason = '-'
        this.updateOrderStatus()
      }
    },
    checkEnableEdit() {
      if (this.$store.getters.modules.includes(',5.08')) {
        this.enableEdit = true
      }
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.13')) {
        this.enableDelete = true
      }
    },
    async updateOrderStatus() {
      let data = {
        inventoryHeaderId: this.inventoryHeaderId,
        statusType: this.ecommerceStatusData,
        reason: this.reason
      }
      let resp = await this.$store.dispatch('updateStatusOfdEcommerceOrder', data)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.ecommerceStatusDialog = false
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case 'Processing':
          return 'Processing'

        case 'Hold':
          return 'Hold'

        case 'Completed':
          return 'Completed'

        case 'Cancelled':
          return 'Cancelled'

        default:
          return 'NA'
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/salesOrder' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'salesOrder.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesOrder' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesOrder.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    expexportToPdfOrderortToPdf() {
      if (this.selectedSalesOrderId !== null) {
        this.selectedSalesOrderId.forEach(salesOrderId => this.idsForSalesOrder.push(salesOrderId.id))
      }
      if (this.idsForSalesOrder.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select atleast one order!', life: 10000})
        return
      }
      if (this.idsForSalesOrder.length > 5) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Sorry Cannot more then 5 order!', life: 10000})
        return
      }
      axios({
        url: globalKey + '/fileDownload/printOrderForKritiCraft/' + this.$store.getters.organisationId + '/' +
          this.$store.getters.userId + '/' + this.idsForSalesOrder,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'Order No' + this.idsForSalesOrder + '.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      this.idsForSalesOrder = []
      this.selectedSalesOrderId = null
    },
    columnNames() {
      for (let i = 1; i < this.$refs.dt.columns.length; i++) {
        this.columnList += this.$refs.dt.columns[i].header + ','
      }
    },
    editSalesOrder(data) {
      this.$router.push({name: 'Sales Order', params: {salesOrder: data}})
    },
    selectedSalesOrder(data) {
      // this.selectedSalesOrderId.push(data.id)
      if (!this.idsForSalesOrder.includes(data)) {
        this.idsForSalesOrder.push(data)
      }
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        inventoryOutHeaderId: this.salesOrderId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteSalesOrder', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
      this.dialogShow = false
    },
    cancel(data) {
      this.dialogShow = false
      this.ecommerceStatusDialog = false
      this.reason = ''
    },
    openDialog(id) {
      this.dialogShow = true
      this.salesOrderId = id
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.ecommerceOrderCompletedLists = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    // Toast,
    InputMask,
    Dropdown,
    Dialogs,
    Checkbox,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// ecommerceCompletedOrder.vue?321fe67e